import Link from 'next/link'

import { ArrowIcon } from '@/components/icons/ArrowIcon'
import { NEWSROOM_BASE_PATH } from '@/utilities/newsroomBasePath'
import type { Newsroom } from '@/payload-types'

interface Props {
  article: Newsroom
  variant?: 'light' | 'dark'
}

export function NewsroomCard({ article, variant = 'light' }: Props) {
  const publishedDate = article.publishedAt
    ? new Date(article.publishedAt).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : null

  const isDark = variant === 'dark'

  return (
    <Link
      href={`${NEWSROOM_BASE_PATH}/${article.slug}`}
      className={`group flex flex-col justify-between transition-colors duration-300 h-full ${
        isDark
          ? 'p-4 md:min-h-[240px]'
          : 'rounded-[12px] border border-black p-6 lg:hover:bg-black lg:min-h-[300px]'
      }`}
    >
      {/* Top section */}
      <div>
        {publishedDate && (
          <p
            className={`body-small transition-colors duration-300 mb-4 ${
              isDark ? 'text-white/70' : 'text-black/70 lg:group-hover:text-white/70'
            }`}
          >
            {publishedDate}
          </p>
        )}
        <h3
          className={`subheading-large xl:subheading-xlarge transition-colors duration-300 line-clamp-3 ${
            isDark ? 'text-white' : 'text-black lg:group-hover:text-white'
          }`}
        >
          {article.title}
        </h3>
      </div>

      {/* Bottom section */}
      <div className="flex items-end justify-end mt-6">
        <span
          className={`subheading-xsmall inline-flex items-center gap-1 transition-colors duration-300 underline underline-offset-2 shrink-0 ${
            isDark ? 'text-white' : 'text-black lg:group-hover:text-white'
          }`}
        >
          Read more
          <ArrowIcon className="shrink-0 size-4 transition-transform duration-300 ease-in-out group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  )
}
